import React from 'react';

import { Messages } from '../../codegen/Localize';
import { IServerUserInfo } from '../../userManagement/users/models/IServerUserInfo';
import { ISiteUserInfo } from '../../userManagement/users/models/ISiteUserInfo';
import { UserSettingsStyle } from '../styles/UserSettingsStyle';
import { ChangePassword, ChangePasswordProps } from './ChangePassword';
import { EmailAndDisplayNameForm } from './EmailAndDisplayNameForm';
import { ManageMfaProps, ManageMfaUrl } from './ManageMfa';

export interface GeneralAuthSettingsProps {
  //auth families
  isDomainFamilyLocal: boolean;
  isDomainFamilyExternal: boolean;
  isDomainFamilyAD: boolean;
  //data
  emailFormInitialValues: EmailAndDisplayNameForm.FormFields;
  //meta data related to business logic
  updateDisplayNameAllowed: boolean;
  siteUser: ISiteUserInfo;
  serverUser: IServerUserInfo;
  isViewerServerAdmin: boolean;
  isViewerSelf: boolean;
  isUserSelf: boolean;
  changePasswordUrl: string;
  manageMfaUrl: string;
  isViewerAdmin: boolean;
}

function getHeader(){
  return (<h2 className={UserSettingsStyle.titleText}>{Messages.userSettings_Account_Header()}</h2>);
}

export function GeneralAuthSettings({emailFormInitialValues, ...passThroughProps}: GeneralAuthSettingsProps) {
  const emailAndDisplayNameFormProps: EmailAndDisplayNameForm.Props = {
    initialValues: emailFormInitialValues,
    ...passThroughProps,
    handleSubmit: EmailAndDisplayNameForm.handleSubmit
  };
  const changePasswordProps: ChangePasswordProps = {
    ...passThroughProps,

  };
  const manageMfaProps: ManageMfaProps = {
    ...passThroughProps
  };
  return (
    <>
    {getHeader()}
    <table>
      <tbody>
        {/* username section */}
        {(passThroughProps.isDomainFamilyAD || passThroughProps.isViewerServerAdmin || passThroughProps.isViewerSelf) &&
          <tr>
            <td className={UserSettingsStyle.tbody} colSpan={3}>
                <table>
                  <tbody>
                    <tr data-tb-test-id="settings-username">
                      <td className={UserSettingsStyle.labelText}>{Messages.username()}</td>
                      <td className="tb-details-value" tb-test-id="tb-username-value-id">{passThroughProps.serverUser.username}</td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
            </td>
          </tr>
        }
        <tr>
          <td className={UserSettingsStyle.tbody} colSpan={3}>
            <EmailAndDisplayNameForm.Form {...emailAndDisplayNameFormProps}/>
          </td>
        </tr>
        <ChangePassword {...changePasswordProps}/>
        <ManageMfaUrl {...manageMfaProps}/>
      </tbody>
    </table>
    </>
  );
}
